import React from 'react'
import { Form, FormSpy } from 'react-final-form'
import { Grid } from '@material-ui/core'
import * as defineSubmittedDateType from './defineSubmittedDateType'
import PageAction from '../pageAction'
import useDefineSubmittedDate from './useDefineSubmittedDate'
import useTranslate from '../../../../../i18n/useTranslate'
import MyAccordion from '../../../../../control/accordion/accordion'
import MyDatePicker from '../../../../../control/datepicker/datepicker'
import Dialog from '../../../../../control/dialog/dialog'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'

const DefineSubmittedDateREC2View: React.FC<defineSubmittedDateType.DefineSubmittedDateViewType> = (props) => {
    const {
        isViewMode,
        minMaxDate,
        displayField,
        configDialog,
        initialValues,
        isShowUpdateDate,
        isSubmittedReceiveDate,
        conditionMinDate,
        onRefDialog,
        onDirtyChang,
        onSubmitForm,
        onClickCancel,
        onChangAnnounceDateREC2,
        onChangCommentDateREC2,
        onChangDocDateREC2,
        handleChangAdvisorDateREC2,
        conditionRequireAll,
        validateForm,
        resetDateExceptDocDate,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues }}
            keepDirtyOnReinitialize={true}
            validate={validateForm}
        >
            {(props) => {
                const { form, handleSubmit, dirty, invalid, errors, values } = props
                const haveToFillAll = conditionRequireAll(values)
                const disabledOtherDate = values.docDate || !displayField?.docDate ? false : true
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {/* <SpecifyDateForm
                                    displayFieldNames={'all'}
                                    disabledFieldNames={'all'}
                                    requiredFieldNames={'all'}
                                /> */}
                                <MyAccordion title={translate.get('LABEL.RECEIVE_DOC_AND_COMMITTEE_MEETING_DATE')}>
                                    <Grid container item justify="flex-start" spacing={2}>
                                        {displayField?.docDate && (
                                            <Grid item xs={12} md={12} lg={12}>
                                                <MyDatePicker
                                                    name="docDate"
                                                    label={translate.get('LABEL.DOC_RECEIVE_DATE')}
                                                    disabled={isViewMode || isSubmittedReceiveDate}
                                                    onChangeValue={(val) => {
                                                        onChangDocDateREC2(val, form)
                                                        resetDateExceptDocDate(form)
                                                    }}
                                                    required
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12} md={12} lg={12}>
                                            <MyDatePicker
                                                name="announceDate"
                                                label={translate.get('LABEL.EXPECTED_ANNOUNCEMENT_DATE')}
                                                disabled={isViewMode || disabledOtherDate}
                                                onChangeValue={(val) => {
                                                    onChangAnnounceDateREC2(val, form)
                                                }}
                                                minDate={
                                                    minMaxDate && minMaxDate.min ? new Date(minMaxDate.min) : undefined
                                                }
                                                required={haveToFillAll || !displayField?.docDate}
                                            />
                                        </Grid>
                                        {displayField?.commentaryDate && (
                                            <>
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <MyDatePicker
                                                        name="commentaryDate"
                                                        label={translate.get('LABEL.COMMITTEE_MEETING_DATE')}
                                                        disabled={isViewMode || disabledOtherDate}
                                                        onChangeValue={onChangCommentDateREC2}
                                                        minDate={conditionMinDate}
                                                        maxDate={
                                                            minMaxDate && minMaxDate.max
                                                                ? new Date(minMaxDate.max)
                                                                : undefined
                                                        }
                                                        required={haveToFillAll || !displayField?.docDate}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <MyDatePicker
                                                        name="advisorDueDate"
                                                        label={translate.get('LABEL.ADVISOR_DUE_DATE')}
                                                        disabled={isViewMode || disabledOtherDate}
                                                        onChangeValue={(val) => {
                                                            handleChangAdvisorDateREC2(val)
                                                        }}
                                                        minDate={conditionMinDate}
                                                        required={haveToFillAll || !displayField?.docDate}
                                                    />
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </MyAccordion>
                            </Grid>
                            {isShowUpdateDate && <DisplayUpdater />}
                        </Grid>
                        {!isViewMode && (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        onClickCancel(dirty)
                                    }}
                                    onClickSave={() => {
                                        form.change('submitType', 'save')
                                        handleSubmit()
                                        invalid &&
                                            errors &&
                                            snackbarAction.openSnackbar({
                                                message: translate.get('MESSAGE.M012'),
                                                type: 'error',
                                            })
                                    }}
                                    onClickSaveDraft={() => {
                                        form.change('submitType', 'draft')
                                        handleSubmit()
                                    }}
                                />
                            </Grid>
                        )}
                        <FormSpy subscription={{ values: true }} onChange={onDirtyChang} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

const DefineSubmittedDateREC2: React.FC<defineSubmittedDateType.DefineSubmittedDateType> = (props) => {
    const useDefineSubmittedDateModel = useDefineSubmittedDate(props)
    return <DefineSubmittedDateREC2View {...useDefineSubmittedDateModel} {...props} />
}

export default DefineSubmittedDateREC2
